// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors-checkout-order-pay-thank-you-post-purchase-side-cart"], () => (__webpack_require__("./sources/ts/post-purchase.tsx")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-checkout-order-pay-thank-you-post-purchase-side-cart"], () => (__webpack_require__("./sources/scss/frontend/post-purchase.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
